export class RouteException extends Error {
  constructor(
    public errorType: ErrorType,
    public title: string,
    public description: string
  ) {
    super(description);

    Object.setPrototypeOf(this, new.target.prototype);
  }
}

type ErrorType = 'forbidden' | 'not-found' | 'unexpected';
